import {sortBy} from 'lodash'

const initialState = {
  paidInvoices: [],
  ui:{
    loading: true
  }
}

export default function paidInvoices(state = initialState, action){
  switch (action.type) {
    case "SUCCESS_FETCH_PAID_INVOICES":
      return {
        ...state,
        paidInvoices: sortBy(action.payload, "id").reverse(),
        ui: {
          ...state.ui,
          loading: false
        }
      }
    case "UPDATE_PAID_INVOICES_UI":
     return {
        ...state,
        ui: {
          ...state.ui,
          ...action.payload,
        }
     }
    default:
      return state;
  }
} 